module.exports = __webpack_public_path__ + "media/images/japan/filters-62dcab071588f9ad49a3f53b4768a448.svg";